<template>
  <div class="mb-6">
    <navigator-search-box
      :title="navigator.title"
      :color="navigator.color"
      :searched="searched"
      :resultTotal="resultTotal"
      @click="search()"
    >
      <div class="p-2 w-full" v-if="navigator.fulltext">
        <label class="mb-2 block" v-html="__('Suche')" for="fulltext"></label>
        <input
          class="input-text h-12"
          id="fulltext"
          name="fulltext"
          type="text"
          v-model="query"
          :placeholder="navigator.placeholder"
          @keypress.enter.tab="search()"
        />
      </div>
      <div class="p-2 w-full" v-if="tags.length">
        <label class="mb-2 block" v-html="__('Kategorien')" for="categories"></label>
        <v-button
          v-for="tag in tags"
          :key="tag.id"
          class="m-1 rounded-full cursor-default"
          color="blue-500"
          small
          active
          border
          icon="fa fa-list"
        >
          {{ tag.name }}
        </v-button>
      </div>
      <div v-for="dropdown in navigator.dropdowns" :key="dropdown.id" class="p-2 w-full md:w-1/2 js-dropdown">
        <label class="mb-2 block" v-html="dropdown.title" :for="dropdown.title"></label>
        <multiselect
          class="bg-white"
          track-by="name"
          label="name"
          :options="dropdown.tags"
          :multiple="true"
          :close-on-select="false"
          v-model="dropdowns[dropdown.id]"
        >
        </multiselect>
      </div>
    </navigator-search-box>

    <p v-if="noResults && !loading" class="w-full text-center p-4">{{ __('Keine Einrichtungen gefunden') }}</p>

    <institution-teaser
      v-for="institution in results"
      :key="institution.id"
      :institution="institution"
      :app-url="appUrl"
      :public="true"
    ></institution-teaser>

    <navigator-loading-animation
      :loading="loading"
      :loadingText="__('Einrichtungen werden geladen')"
    ></navigator-loading-animation>

    <div class="w-full flex flex-col items-center mb-4" v-if="moreResults && !loading">
      <v-button
        :color="navigator.color"
        :class="`bg-${navigator.color}-700 w-full text-white border-${navigator.color}-700 md:w-1/3`"
        @click="loadMoreResults()"
        title="Mehr Einrichtungen anzeigen"
        icon="fa fa-caret-down"
      >
        {{ __('Mehr Einrichtungen anzeigen') }}
      </v-button>
    </div>
  </div>
</template>

<script>
import SearchBox from '@components/NavigatorUI/SearchBox.vue';
import LoadingAnimation from '@components/NavigatorUI/LoadingAnimation.vue';

export default {
  components: {
    'navigator-search-box': SearchBox,
    'navigator-loading-animation': LoadingAnimation,
  },
  props: {
    navigator: {
      type: Object,
      required: true,
    },
    appUrl: {
      type: String,
      default: '/',
    },
  },
  data() {
    return {
      query: '',
      search_timeout: undefined,
      results: [],
      total: 0,
      dropdowns: {},
      tags: [],
      loading: false,
      searched: false,
      page: 1,
    };
  },
  mounted() {
    this.tags = this.navigator.tags;
    if (0 < this.tags.length) {
      this.$set(this.dropdowns, 0, this.tags);
    }
    if (this.getUrlParams().get('query')) {
      this.query = this.getUrlParams().get('query');
    }
    this.loadTagsByNames();
  },
  methods: {
    loadTagsByNames() {
      var tag_names = this.getUrlParams().get('tags');
      if (tag_names) {
        axios.get(`${this.appUrl}api/navigator/tags/${tag_names}`).then((response) => {
          this.tags = response.data;
          this.$set(this.dropdowns, 0, this.tags);
        });
      }
    },
    getUrlParams() {
      var url_string = window.location.href.toLowerCase();
      var url = new URL(url_string);
      return url.searchParams;
    },
    search() {
      this.loading = true;
      this.results = [];
      this.total = 0;
      this.page = 1;
      this.sendQuery();
    },
    sendQuery() {
      axios
        .post(`${this.appUrl}api/navigator/search`, {
          dropdowns: this.dropdowns,
          query: this.query,
          page: this.page,
          institutions: this.navigator.institutions.map((institution) => institution.id),
        })
        .then((response) => {
          this.setResults(response);
        });
    },
    setResults(response) {
      if (this.results.length > 0) {
        this.results = this.results.concat(response.data.data);
      } else {
        this.total = response.data.total;
        this.results = response.data.data;
        this.searched = true;
      }
      this.loading = false;
    },
    loadMoreResults() {
      this.page++;
      this.loading = true;
      this.sendQuery();
    },
  },
  computed: {
    resultTotal() {
      return this.total > 1 ? this.total + ' Einrichtungen' : this.total + ' Einrichtung';
    },
    moreResults() {
      return this.total > this.results.length && this.results.length > 0;
    },
    noResults() {
      return this.searched && this.results.length == 0;
    },
  },
};
</script>
